var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("自動化模組")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("會員事件設定")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-4 col-xl-3 mb-2 font-weight-bold"
  }, [_vm._v("會員事件設定")]), _c('div', {
    staticClass: "\n        col-12 col-xl-9 mb-2\n        d-flex\n        flex-xl-row\n        align-items-center\n        "
  }, [_vm.checkPermission([_vm.consts.MEMBER_EVENT_CREATE]) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-show",
      modifiers: {
        "modal-show": true
      }
    }],
    staticClass: "flex-shrink-0 mr-3",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增事件 ")]) : _vm._e(), _c('b-form-select', {
    staticClass: "form-select mr-3",
    attrs: {
      "options": _vm.typeOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.memberType,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "memberType", $$v);
      },
      expression: "query.memberType"
    }
  }), _c('b-form-select', {
    staticClass: "form-select mr-3",
    attrs: {
      "options": _vm.enableOption
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  }), _c('b-form-select', {
    staticClass: "form-select mr-3",
    attrs: {
      "options": _vm.processingOption
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.process,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "process", $$v);
      },
      expression: "query.process"
    }
  }), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "輸入活動名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_enabled ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_enabled ? '啟用' : '未啟用') + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.MEMBER_EVENT_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'AutoMarketingView',
              params: {
                config_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MEMBER_EVENT_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'AutoMarketingEdit',
              params: {
                config_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MEMBER_EVENT_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-show",
      "ok-title": "關閉",
      "centered": "",
      "ok-only": ""
    }
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "好友事件"
    }
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AutoMarketingMemberEventForm',
        params: {
          type: 'line_follow'
        }
      }
    }
  }, [_vm._v("新增")])], 1), _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "註冊事件"
    }
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AutoMarketingMemberEventForm',
        params: {
          type: 'registered'
        }
      }
    }
  }, [_vm._v("新增")])], 1), _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "生日事件"
    }
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AutoMarketingMemberEventForm',
        params: {
          type: 'birthday'
        }
      }
    }
  }, [_vm._v("新增")])], 1), _c('b-card', {
    attrs: {
      "title": "封鎖事件"
    }
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AutoMarketingMemberEventForm',
        params: {
          type: 'line_unfollow'
        }
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }